<template>
  <div class="chart-bar" />
</template>

<script>
import chartInitMixin from '@/views/mixin/chartInitMixin'
import * as echarts from 'echarts'

export default {
  name: 'chart-bar-protocol', // 通信协议Top5
  props: {
    chartTitle: {
      type: String,
      required: false,
    },
    chartData: {
      type: Array,
      required: true,
    }
  },
  mixins: [ chartInitMixin, ],
  watch: {
    'chartData': {
      deep: true,
      handler() {
        this.update()
      }
    },
  },
  methods: {
    update() {
      if(!this.chartData.length) return
      const seriesData = this.chartData.map(item => item.value)
      const xAxisData = this.chartData.map(item => item.name)
      console.log(seriesData, xAxisData)
      if (!xAxisData || !seriesData) return
      const option = {
        color: '#3398DB',
        title: {
          show: false,
          text: this.chartTitle,
          textStyle: {
            fontFamily: '"OPPOSans R", "阿里巴巴普惠体 R", PingFangSC-Medium, PingFangSC, Arial, Helvetica, 黑体, sans-serif',
            fontSize: 15,
            fontWeight: '100',
            color: '#FFF1D9',
            textShadowBlur: 0,
          },
          left: 'left',
          top: '0',
        },
        tooltip: {
          show: false,
        },
        grid: {
          top: 5,
          right: 6,
          height: 170,
        },
        legend: {
          show: false,
        },
        yAxis: [
          {
            type: 'category',
            data: xAxisData,
            inverse: true,
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLine: {
              show: false,
            },
            axisLabel: { // 坐标轴样式
              interval: 0, // 强制显示所有标签
              rotate: 0, // 如果标签过长，可以旋转显示
              fontSize: 10,
              color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
            },
          },
          { // 取值 *****
            show: true,
            type: 'category',
            data: seriesData,
            inverse: true,
            position: 'right',
            offset: 5,
            z: 0,
            zlevel: 3,
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLabel: {
              fontSize: 12,
              color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
              inside: true,
              height: 50,
              padding: [10, 0, 10, 0]
            },
            axisLine: {
              show: false,
            },
            splitLine: { // 网格线
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.15)',
                width: 1,
                type: 'dashed',
              }
            },
          },
        ],
        xAxis: [
          {
            show: false,
            type: 'value',
            position: 'left',
            axisLabel: {
              formatter: '{value}', // 格式化y轴标签
              fontSize: 10,
              color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
            },
            splitLine: { // 网格线
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.15)',
                width: 1,
                type: 'dashed',
              }
            },
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth: 8,
            color: '#00b6e7',
            showBackground: true,
            backgroundStyle: {
              color: "#293F5E"
            },
            itemStyle: {
              // barBorderRadius: [2, 2, 0, 0],
              color: function (params) {
                return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {offset: 1, color: 'rgba(240,213,68,1)'},
                  {offset: 0.5, color: 'rgba(240,213,68,0.5)'},
                  {offset: 0, color: 'rgba(240,213,68,0.05)'},
                ])
              },
            },
            z: 0,
            zlevel: 1,
            data: seriesData
          },
        ]
      }
      this.chart.setOption(option)
      // console.log('#option#', option)
    }
  }
}
</script>
